export const PLAYERS_STATE = "market_research_players";
